import { Dispatch, FC, Fragment, SetStateAction, useEffect } from 'react'
import { Contents } from '../../../components/layouts'
import { GridLayout, GridLayoutItem } from '@progress/kendo-react-layout'
import { Switch, SwitchChangeEvent } from '@progress/kendo-react-inputs'
import { useAppSelector } from '../../../stores'
import { BuildingInfoGet, ExpenseInfo } from '@gateway.Building'
import produce from 'immer'

export interface BuildingExpenseProps {
  buildingInfo: BuildingInfoGet
  expenseInfos: ExpenseInfo[] | null
  expenseInfoPutState: ExpenseInfo[]
  setExpenseInfoPutState: Dispatch<SetStateAction<ExpenseInfo[]>>
}

export const BuildingExpense: FC<BuildingExpenseProps> = (props) => {
  const common = useAppSelector((x) => x.common)
  const codeNameExpenses = common.initialData.codeNames('HI01')

  const toggleExpenseTarget = (event: SwitchChangeEvent) => {
    props.setExpenseInfoPutState(
      produce((draft) => {
        const targetIndex = draft.findIndex(ex => ex.expenseCode === event.target.name)
        draft[targetIndex].expenseNotApplicableFlg = event.value ? 1 : 0
      })
    )
  }

  useEffect(() => {
    props.setExpenseInfoPutState(props.expenseInfos ?? [])
  }, [])

  return (
    <Contents>
      <GridLayout style={{ width: '100%' }} gap={{ rows: '3px', cols: '0px' }}>
        {codeNameExpenses.map((expense, index) => {
          return (
            <Fragment key={index}>
              <GridLayoutItem row={index % 7 + 1} col={Math.floor(index / 7) * 2 + 1} colSpan={3}>
                <span style={{ fontSize: '1.0em' }}>{expense.NAME}</span>
              </GridLayoutItem>
              <GridLayoutItem row={index % 7 + 1} col={Math.floor(index / 7) * 2 + 2}>
                <Switch
                  name={expense.CODE}
                  size={'medium'}
                  checked={props.expenseInfoPutState.find(ex => ex.expenseCode === expense.CODE)?.expenseNotApplicableFlg === 1}
                  onChange={toggleExpenseTarget}
                  disabled={!(props.expenseInfos?.some(ex => ex.expenseCode === expense.CODE) ?? false)}
                />
              </GridLayoutItem>
            </Fragment>
          )
        })}
      </GridLayout>
    </Contents>
  )
}
